<template>
    <div data-v-animate v-if="ready">
        <transition
            appear
            name="appear"
            v-bind="$attrs"
            v-on="$listeners"
            @enter="enter"
            @afterEnter="after"
            @leave="leave">
            <div v-if="string">
                <p v-html="string" />
            </div>
            <div v-else>
                <slot />
            </div>
        </transition>
    </div>
    <div v-else style="visibility:hidden">
        <div v-if="string">
            <p v-html="string" />
        </div>
        <div v-else>
            <slot />
        </div>
    </div>
</template>
<style lang="scss" scoped>
[data-v-animate] {
    position: relative;
    overflow: hidden
}
* > :only-child {
    // will-change: transform;
    // transform: translateZ(0);
    backface-visibility: hidden;
    perspective: 1000px
}
.appear-enter-active,
.appear-leave-active {
    animation-duration: 1s;
    animation-timing-function: var(--timing, ease-out);
    animation-fill-mode: both;
    animation-name: appear
}

.appear-leave-active {
    animation-direction: reverse
}

@keyframes appear {
    0% {
        opacity: 0;
        transform: translate3d(0px, 150%, 0)
    }
    100% {
        opacity: 1;
        transform: translate3d(0px, 0%, 0)
    }
}

</style>
<script>
export default {
    name: 'AnimateIn',
    props: ['string', 'ready', 'delay'],
    methods: {
        enter( element ) {
            element.style.animationDelay = this.delay + 'ms'
        },
        after( element ) {
            this.$el.classList.add('has-overflow')
            element.style.animationDelay = null
        },
        leave(/* element */) {
            this.$el.classList.remove('has-overflow')
        }
    }
}
</script>
